export const PATTERN_SEPARATOR = '___';

export const abbreviateName = (label, minChar = 8, joinWith = '.') => {
  if (typeof label !== 'string') return label;

  const trimmed = label.trim();
  if (trimmed.length <= minChar) return trimmed;

  const words = trimmed.split(/\s+/).filter(Boolean);
  if (words.length === 0) return trimmed;

  // Pointeurs sur le nombre de caractères pris par mot
  const taken = new Array(words.length).fill(0);
  let collected = 0;
  let progressed = true;

  // Démarrage: on prend au moins 1 char par mot si possible (meilleure lisibilité)
  for (let i = 0; i < words.length && collected < minChar; i++) {
    if (taken[i] < words[i].length) {
      taken[i] += 1;
      collected += 1;
    }
  }

  // Puis on continue en round-robin jusqu'à minChar ou épuisement total
  while (collected < minChar && progressed) {
    progressed = false;
    for (let i = 0; i < words.length && collected < minChar; i++) {
      if (taken[i] < words[i].length) {
        taken[i] += 1;
        collected += 1;
        progressed = true;
      }
    }
  }

  // Construit l’abréviation
  let abbreviation = words.map((w, i) => w.slice(0, taken[i])).join(joinWith);

  // Si on a quand même dépassé (rare), on coupe proprement sans casser les mots
  const withoutSepLen = abbreviation.split(joinWith).join('').length;
  if (withoutSepLen > minChar) {
    // Réduire depuis la fin
    let over = withoutSepLen - minChar;
    for (let i = words.length - 1; i >= 0 && over > 0; i--) {
      const reducible = Math.min(taken[i], over);
      taken[i] -= reducible;
      over -= reducible;
    }
    abbreviation = words
      .map((w, i) => w.slice(0, Math.max(0, taken[i])))
      .join(joinWith);
  }

  // Nettoyage: pas de séparateur en fin
  const trailingSep = new RegExp(`${escapeRegExp(joinWith)}$`);
  abbreviation = abbreviation.replace(trailingSep, '');

  return abbreviation || trimmed;
};

// Utils
export const splitPattern = (pattern) => {
  return pattern.includes(PATTERN_SEPARATOR)
    ? pattern.split(PATTERN_SEPARATOR)
    : pattern.split('_');
};

export const joinPattern = (parts) => parts.join(PATTERN_SEPARATOR);

export const removeQuote = (str) => {
  return typeof str === 'string' && str.startsWith('"') && str.endsWith('"')
    ? str.slice(1, -1)
    : str;
};

// Échappement pour regex
function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
